import React from 'react';

import { Box, Typography } from '@mui/material';

import { useWatch } from 'react-hook-form';

import { Actions } from '../../../../constants/actions';
import BooleanRadioGroupInput from '../../../../customFields/BooleanRadioGroupInput';

const getPrompt = (action: Actions) => {
  if (action === 'RuleVersionRelease') return 'Require peer review for releasing test versions?';
  return 'Require peer review for publishing live versions?';
};

const RequirePeerReviewInput = ({ action }: { action: Actions }) => {
  const isEnabled = useWatch({ name: `permissions.${action}.enabled` });

  if (!isEnabled) return null;

  return (
    <Box display="flex" alignItems="center" gap={6}>
      <Typography>{getPrompt(action)}</Typography>
      <BooleanRadioGroupInput
        source={`permissions.${action}.attributes.requirePeerReview`}
        label=""
        defaultValue={false}
        helperText={false}
        margin="none"
      />
    </Box>
  );
};

export default RequirePeerReviewInput;
